import React, { useState } from "react";

interface BannerCounterProps {
  value?: number; // Controlled quantity
  onChange?: (value: number) => void;
}

const BannerCounter: React.FC<BannerCounterProps> = ({ value, onChange }) => {
  const [internalQuantity, setInternalQuantity] = useState<number>(0);
  // If parent supplies `value` prop, use it; otherwise, use internal state
  const quantity = value !== undefined ? value : internalQuantity;

  const setQuantity = (val: number) => {
    if (value === undefined) setInternalQuantity(val); // Only update internal state if uncontrolled
    if (onChange) onChange(val); // Always call parent onChange
  };

  const handleIncrement = () => {
    if (quantity < 99) {
      const newQuantity = quantity + 1;
      setQuantity(newQuantity);
      if (onChange) onChange(newQuantity); // Trigger onChange callback
    }
  };

  const handleDecrement = () => {
    if (quantity > 0) {
      const newQuantity = quantity - 1;
      setQuantity(newQuantity);
      if (onChange) onChange(newQuantity); // Trigger onChange callback
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const numericValue = parseInt(value, 10);

    if (value === "") {
      setQuantity(0); // Reset to 0 if input is empty
      if (onChange) onChange(0); // Trigger onChange callback
    } else if (!isNaN(numericValue) && numericValue >= 0 && numericValue <= 99) {
      setQuantity(numericValue); // Update state with valid numbers
      if (onChange) onChange(numericValue); // Trigger onChange callback
    }
  };

  return (
    <div className="custom-increment">
      <div className="input-group">
        <span className="input-group-btn float-start">
          <button
            type="button"
            className="quantity-left-minus btn btn-light btn-number"
            data-type="minus"
            onClick={handleDecrement}
          >
            <span>
              <i className="isax isax-minus" />
            </span>
          </button>
        </span>
        <input
          type="text"
          name="quantity"
          className="input-number text-center"
          value={quantity.toString()} // Convert number to string for input
          onChange={handleChange} // Allow manual edits
        />
        <span className="input-group-btn float-end">
          <button
            type="button"
            className="quantity-right-plus btn btn-light btn-number"
            data-type="plus"
            onClick={handleIncrement}
          >
            <span>
              <i className="isax isax-add" />
            </span>
          </button>
        </span>
      </div>
    </div>
  );
};

export default BannerCounter;